import { FETCH_USER_PROFILE } from '../actions/currentUser';

const initialState = {
  fetching: false,
  profile: {
    first_name: "",
    last_name: ""
  }
}

const currentUser = ( state = initialState, action) => {
  switch(action.type) {
    case `${FETCH_USER_PROFILE}_PENDING`:
      return { ...state, fetching: true };
    case `${FETCH_USER_PROFILE}_FULFILLED`:
      return { ...state, fetching: false, profile: action.payload };
    default:
      return state
  }
}

export default currentUser;



// WEBPACK FOOTER //
// ./src/reducers/currentUser.js